import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as plantActions from '../_actions/plant';
import { Plant } from '../_models';

export interface PlantState extends EntityState<Plant> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Plant> = createEntityAdapter<Plant>();

const initialState: PlantState = adapter.getInitialState({
  loading: false,
  error: null,
});

const plantReducer = createReducer(
  initialState,

  on(plantActions.loadPlants, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(plantActions.loadplantsSuccess, (state, { plants }) =>
    adapter.setAll(plants, { ...state, loading: false })
  ),

  on(plantActions.loadplantsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(plantActions.addplantSuccess, (state, { plant }) => adapter.addOne(plant, state)),

  on(plantActions.updateplantSuccess, (state, { plant }) => adapter.upsertOne(plant, state)),

  on(plantActions.deleteplantSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    plantActions.addplantFailure,
    plantActions.updateplantFailure,
    plantActions.deleteplantFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: PlantState | undefined, action: Action) {
  return plantReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
